import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from './scenes/MainScene';

interface PhaserPlatformerDemoProps {
}

interface PhaserPlatformerDemoState {
}

const gameConfig: GameConfig = {
    title: "Platformer Demo - Phaser",
    version: "0.2-demo",
    width: 800, // This is only here because this demo is old
    height: 600,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserPlatformerDemo extends React.Component<PhaserPlatformerDemoProps, PhaserPlatformerDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserPlatformerDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserPlatformerDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserPlatformerDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserPlatformerDemo/Main.tsx